document.addEventListener('DOMContentLoaded', function () {
  var items = document.querySelectorAll('.stl-item');

  items.forEach(function (item) {
    var qtyInput = item.querySelector('.stl-qty-input');
    var minusBtn = item.querySelector('.stl-qty-minus');
    var plusBtn = item.querySelector('.stl-qty-plus');
    var addBtn = item.querySelector('.stl-add-to-cart');
    var errorEl = item.querySelector('.stl-add-error');
    var sizeInputs = item.querySelectorAll('.stl-size-input');
    var sizeToggle = item.querySelector('.stl-size-toggle');
    var sizePicker = item.querySelector('.stl-size-picker');

    if (sizeToggle && sizePicker) {
      sizeToggle.addEventListener('click', function () {
        sizePicker.classList.toggle('stl-size-picker--open');
      });
    }

    if (minusBtn && qtyInput) {
      minusBtn.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        if (val > 1) qtyInput.value = val - 1;
      });
    }
    if (plusBtn && qtyInput) {
      plusBtn.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = val + 1;
      });
    }
    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        var val = parseInt(qtyInput.value, 10);
        if (!val || val < 1) qtyInput.value = 1;
      });
    }

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (errorEl) {
          errorEl.hidden = true;
          errorEl.textContent = '';
        }

        var variantsRaw = addBtn.getAttribute('data-variants');
        var variants = [];
        try {
          variants = JSON.parse(variantsRaw);
        } catch (e) {
          variants = [];
        }

        var selectedSize = null;
        sizeInputs.forEach(function (input) {
          if (input.checked) selectedSize = input.value;
        });

        var matchedVariant = null;
        if (selectedSize && variants.length) {
          matchedVariant = variants.find(function (v) {
            return v.title === selectedSize || (v.options && v.options.indexOf(selectedSize) !== -1);
          });
        }
        if (!matchedVariant && variants.length) {
          matchedVariant = variants[0];
        }

        if (!matchedVariant) {
          if (errorEl) {
            errorEl.hidden = false;
            errorEl.textContent = 'This product has no purchasable variant.';
          }
          return;
        }

        var quantity = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;

        addBtn.disabled = true;
        var originalText = addBtn.textContent;
        addBtn.textContent = 'Adding…';

        var cartAddUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
          ? window.Shopify.routes.root + 'cart/add.js'
          : '/cart/add.js';

        fetch(cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: matchedVariant.id, quantity: quantity }]
          })
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (data) {
                throw new Error(data.description || data.message || 'Could not add to cart');
              });
            }
            return response.json();
          })
          .then(function () {
            addBtn.classList.add('stl-added');
            addBtn.textContent = 'Added';
            window.location.reload();
          })
          .catch(function (err) {
            addBtn.textContent = originalText;
            addBtn.disabled = false;
            if (errorEl) {
              errorEl.hidden = false;
              errorEl.textContent = err.message || 'Could not add to cart. Please try again.';
            }
          });
      });
    }
  });
});
